import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgInfoCircle = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M12 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M11 10.25a.75.75 0 0 0 0 1.5.25.25 0 0 1 .25.25v2.5c0 .966.784 1.75 1.75 1.75h.5a.75.75 0 0 0 0-1.5H13a.25.25 0 0 1-.25-.25V12A1.75 1.75 0 0 0 11 10.25"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20M8.747 4.147a8.5 8.5 0 1 1 6.506 15.706A8.5 8.5 0 0 1 8.747 4.147"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgInfoCircle;
